import axios from 'axios';


import {useEffect, useState, FC} from 'react';
import * as Accordion from '@radix-ui/react-accordion';
import {actions} from '../store/actions';
import {URLS} from '../config';
import {theme} from '../constants';
import {components} from '../components';
import {TbRepeat} from 'react-icons/tb';
import { hooks } from '../hooks';
import {Typography, Tag} from 'antd';
const {Title, Text, Paragraph} = Typography;

export const OrderHistory: FC = () => {
  const dispatch = hooks.useAppDispatch();
  const navigate = hooks.useAppNavigate();
  const token = hooks.useAppSelector(state => state.auth.token);
  const [loading, setLoading] = useState(false);
  const [ordersData, setOrdersData] = useState<any[]>([]);
  const [openOrderId, setOpenOrderId] = useState<number | null>(null); // ✅ state برای نمایش جزئیات

  const getData = async () => {
    setLoading(true);
    try {
      const orderResponseData = await axios
        .get(URLS.GET_ORDERS, {
          headers: {
            Authorization: `JWT ${token}`,
          },
        })
        .then(res => res.data);
        setOrdersData(orderResponseData);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getData();
  }, []);

  const renderHeader = () => {
    return <components.Header goBack={true} title='تاریخچه سفارشات' />;
  };



  const renderHistoryContent = (): JSX.Element => {
    if (loading) return <components.Loading />;

    return (
      <div className="space-y-6 px-4 pb-10">
        {ordersData.map(order => {
          const isOpen = openOrderId === order.id;

          return (
            <div key={order.id} className="bg-white rounded-lg shadow-sm border border-gray-200">
              {/* Order Summary */}
              <div
                className="p-6 cursor-pointer hover:bg-gray-50 transition-colors"
                onClick={() => setOpenOrderId(isOpen ? null : order.id)}
              >
                <div className="flex flex-col md:flex-row justify-between items-start md:items-center">
                  <div className="mb-4 md:mb-0 space-y-1">
                    <div className="flex items-center gap-4">
                      <span className="text-sm font-medium text-gray-900">
                        سفارش #{order.id}
                      </span>
                          <span
                              className={`px-3 py-1 rounded-full text-xs font-medium
                                ${
                                  order.status === 1
                                    ? 'bg-yellow-100 text-yellow-800'
                                    : order.status === 2
                                    ? 'bg-red-100 text-red-800'
                                    : order.status === 3
                                    ? 'bg-green-100 text-green-800'
                                    : 'bg-gray-100 text-gray-700'
                                }`}
                            >
                              {order.status === 1
                                ? 'در حال پردازش'
                                : order.status === 2
                                ? 'لغو شده'
                                : order.status === 3
                                ? 'انجام شده'
                                : 'وضعیت نامشخص'}
                            </span>
                    </div>
                    <p className="text-sm text-gray-500">تاریخ ثبت: {order.jalali_created_time}</p>
                  </div>
                  <div className="text-right">
                  <div style={{marginBottom: 16}}>
                          {order.price_after_discount ? (
                            <>
                              <Text delete style={{fontSize: 12, marginLeft: 8}}>
                                {order.total_price.toLocaleString()} تومان
                              </Text>
                              <Text strong type='danger' style={{fontSize: 15}}>
                                {order.price_after_discount.toLocaleString()} تومان
                              </Text>
                              <Tag color='green' style={{marginRight: 8}}>
                                خرید با تخفیف
                              </Tag>
                            </>
                          ) : (
                            <Text strong style={{fontSize: 12}}>
                              {order.total_price.toLocaleString()} تومان
                            </Text>
    )}
                           </div>
                    <p className="text-sm text-gray-500">{order.products.length} آیتم</p>
                  </div>
                </div>
              </div>

              {/* Order Details */}
              {isOpen && (
                <div className="border-t border-gray-100">
                  <div className="p-6 space-y-6">
                    <h3 className="text-sm font-medium text-gray-900">اقلام خریداری‌شده</h3>
                    <div className="space-y-4">
                      {order.products.map((item: any) => (
                        <div key={item.id} className="flex items-center gap-4">
                          <img
                            src={item.product.image}
                            alt={item.product.title}
                            className="w-16 h-16 object-cover rounded-md border border-gray-200"
                          />
                          <div className="flex-1">
                            <p className="text-sm font-medium text-gray-900">{item.product.title}</p>
                            <p className="text-sm text-gray-500">تعداد: {item.amount}</p>
                          </div>
                          <p className="text-sm font-medium text-gray-900">{item.fee.toLocaleString()} تومان</p>
                        </div>
                      ))}
                    </div>
                  </div>

                  {/* Actions */}
                  <div className="border-t border-gray-100 px-6 py-4 bg-gray-50 flex justify-end gap-4">
                    {/* <button className="px-4 py-2 border border-gray-300 rounded-md text-sm font-medium text-gray-700 hover:bg-gray-100">
                      مشاهده فاکتور
                    </button>
                    <button className="px-4 py-2 bg-blue-600 rounded-md text-sm font-medium text-white hover:bg-blue-700 flex items-center gap-1">
                      <TbRepeat />
                      سفارش مجدد
                    </button> */}
                  </div>
                </div>
              )}
            </div>
          );
        })}
      </div>
    );
  };

  const renderEmptyContent = () => {
    if (loading) return <components.TabLoader />;

    return (
      <div style={{padding: '50px 20px 20px 20px'}}>
        <img
          src={require('../assets/icons/05.png')}
          alt='order successful'
          style={{
            width: 225.18,
            display: 'block',
            margin: '0 auto',
            marginBottom: 14,
          }}
        />
        <h2
          style={{
            margin: 0,
            textAlign: 'center',
            ...theme.fonts.Mulish_700Bold,
            fontSize: 22,
            lineHeight: 1.2,
            color: theme.colors.mainColor,
            marginBottom: 14,
            textTransform: 'capitalize',
            whiteSpace: 'pre-line',
          }}
        >
          تاریخچه سفارشات شما{'\n'}در حال حاضر خالی است!
        </h2>

        <components.Button
          title='خرید اکنون'
          onClick={() => {
            dispatch(actions.resetFilters());
            navigate('/shop');
          }}
          containerStyle={{marginBottom: 10}}
        />
      </div>
    );
  };

  const renderContent = (): JSX.Element => {
    if (loading) return <components.Loading />;
    
    if (ordersData === undefined || ordersData.length == 0) {
      return (renderEmptyContent())
  }else{
    return (renderHistoryContent());
  }

  };
  return (
    <>
      {renderHeader()}
      {renderContent()}
    </>
  );
};
